import { palette } from '../../../styles/variables'
import { MIXPANEL_PROPS } from '../../mixpanel'

export const appBanner = {
  background: 'linear-gradient(180deg, #011928 0%, #082F46 100%)',
  bgAnimation: 'snowfall',
  color: palette.white,
  boldColor: '#52CBFF',
  textBanner: 'holiday_banner',
  flagText: 'holiday',
  flagBackground:
    'linear-gradient(90deg, #F13D56 0%, #DC1B36 10%, #DC1B36 90%, #F13D56 100%)',
  showFlagFly: true,
  counter: {
    card: {
      background: [
        'linear-gradient(332deg, rgba(24, 34, 46, 0.90) 20%, rgba(25, 48, 62, 0.90) 100%)',
        'linear-gradient(332deg, rgba(3, 23, 36, 0.90) 30%, rgba(24, 34, 46, 0.90) 70%)',
      ],
      borderRadius: '2px',
      border: '1px solid #5B7484',
      boxShadow: '0px 4px 14px 0px rgba(255, 94, 41, 0.10)',
    },
    divider: {
      color: '#52CBFF',
    },
  },
  purchaseButtonLocation:
    MIXPANEL_PROPS?.PURCHASE_BUTTON_LOCATION?.values?.HOLIDAY_UBS_BANNER,
}

export const holidayGlobalAlertId = '3572f2b7-7813-4d70-af0b-ccf394c00875'
